export enum FileFormat {
  MP3 = 1,
  WAV = 2,
  AskEveryTime = 3,
}
